import React, {useContext} from 'react'
import { Selected } from '../../../../context/context'
import { 
    Content,
    Title,
    Option,
    Nota,
} from './Elements'
import { 
    contentMotion,
    titleMotion,
    optionMotion,
    notaMotion,
} from './Motion'

const LogoPosition = ({ setSteps }) => {

    const [selected, setSelected] = useContext(Selected)

    const handleClick = (e) => {

        setSelected({...selected, ubicacion: e.target.value})
        
        if(e.target.value === "ambos") {
            setSteps(4)
        } else {
            setSteps(3)
        }
    }

    return(
        <Content
        variants={contentMotion}
        initial='initial'
        animate='animate'
        exit='exit'
        >
            <Title
            variants={titleMotion}
            >Elegí la posición del logo</Title>
            <Option
            variants={optionMotion}
            value="frente"
            onClick={handleClick}>Frente</Option>
            <Option
            variants={optionMotion}
            value="dorso" 
            onClick={handleClick}>Dorso</Option>
            <Option
            variants={optionMotion}
            value="ambos" 
            onClick={handleClick}>Frente &amp; Dorso</Option>
            <Nota
            variants={notaMotion}
            initial="initial"
            animate="animate"
            exit="exit"
            >*frente: logo chico, dorso: logo grande</Nota>
        </Content>
    )
}

export default LogoPosition